import { Information } from '@/modules/move/components/information/information';
import { Report } from '@/modules/move/components/report/report';
import useMove from '@/modules/move/hooks/useMove/useMove';
import React from 'react';

import { useHistoryParams } from '@/navigation';

const Details: React.FC = () => {
  const { moveId } = useHistoryParams();
  const { isLoading, move, setMove, transformedSheets, observationSheets, attachments } =
    useMove(moveId);

  return (
    <Information
      isLoading={isLoading}
      move={move}
      setMove={setMove}
      transformedSheets={transformedSheets}
      observationSheets={observationSheets}
      attachments={attachments}>
      <Report move={move} loading={isLoading} />
    </Information>
  );
};

export default Details;
